import styled from '@emotion/styled';

import { Typography } from '@ssa-ui-kit/core';

export const BmiLabel = styled(Typography)`
  position: absolute;

  left: 65%;
`;
